/** CMS page slug for prospect portal videos (Genie Tenant Portal Content admin). */
export const PROSPECT_PORTAL_PAGE_SLUG = 'prospect';

/** Discovery Call — intro video above the booking calendar. */
export const QUALIFICATION_LANDING_VIDEO_SECTION = 'qualification-landing-video';

/** Discovery Call — video sales letter beside the booking calendar. */
export const VIDEO_SALES_LETTER_SECTION = 'video-sales-letter';

/** @deprecated Renamed to {@link VIDEO_SALES_LETTER_SECTION}. Still accepted as the same video. */
export const LEGACY_QUALIFICATION_VSL_SECTION = 'qualification-vsl';
